export const version = '2.21.21';
//# sourceMappingURL=version.js.map